module.exports = __webpack_public_path__ + "static/img/preview-05.02c19793.webp";